
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-custom-demo-custom-provider-width-ui"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.en-US.md?type=demo')
};